/* eslint-disable no-undef */
(function () {
  'use strict';

  window.OletLens = window.OletLens || {};

  var PROPS = {
    BUNDLE_KEY: '_bundle_key',
    BUNDLE_ROLE: '_bundle_role',
    USAGE_TYPE: '_usage_type',
    RX_METHOD: '_rx_method',
    RX_JSON: '_rx_json',
    RX_FILE_URL: '_rx_file_url',
  };

  var BUNDLE_ROLES = {
    FRAME: 'frame',
    LENS_BASE: 'lens_base',
    ADDON: 'addon',
  };

  var STEPS = {
    USAGE: 1,
    PRESCRIPTION_TYPE: 2,
    READING_TYPE: 2.5,
    PRESCRIPTION: 3,
    LENS_TYPE: 4,
    SUNGLASSES: 5,
    ADDON: 6,
    SUMMARY: 7,
  };

  var STEP_TITLES = {};
  STEP_TITLES[1] = 'Choose Your Usage';
  STEP_TITLES[2] = 'Choose Prescription Type';
  STEP_TITLES[2.5] = 'Choose Reading Strength';
  STEP_TITLES[3] = 'Enter Your Prescription';
  STEP_TITLES[4] = 'Choose Your Lens Type';
  /** When set for the current usage, overrides STEP_TITLES[LENS_TYPE] (step 4). */
  var STEP_TITLE_LENS_SELECTION_BY_USAGE = {
    single_vision: 'Choose Your Lens Type',
    bifocals: 'Choose Your Lens Type',
    progressives: 'Choose Your Lens Package',
    reading: 'Choose Your Lens Type',
    'non-prescription': 'Choose Your Lens Type',
  };
  var POLYCARBONATE_NOTE =
    'Note: Polycarbonate lenses cannot be upgraded with sunglass tint. Anti-reflective coating is available as a free optional feature in the next step.';
  var PROGRESSIVES_PACKAGE_NOTE =
    'Note: Progressive lenses provide distance, intermediate, and near vision in one pair of glasses. Lens performance may vary based on your prescription, frame choice, and adaptation period.';
  var BIFOCALS_NOTE =
    'Note: Bifocal lenses combine distance and near vision in one pair of glasses, with a visible segment for reading. They are commonly used for distance viewing and close-up tasks such as reading.';
  var READING_NOTE =
    'Note: Reading lenses are designed for near vision and close-up tasks. If you need distance correction, please choose single vision, bifocal, or progressive prescription lenses instead.';
  STEP_TITLES[5] = 'Sunglasses Upgrade (Optional)';
  STEP_TITLES[6] = 'Additional Features (Multi-Select)';
  STEP_TITLES[7] = 'Summary';

  var LENS_BASE_VARIANTS = {
    single_vision: {
      basic: 46976171147415,
      polycarbonate: 47006871126167,
      standard: 47006882955415,
      premium: 47006884036759,
      elite: 47006897963159,
    },
    progressives: {
      basic: 47006910414999,
      standard: 47006911201431,
      premium: 47006922277015,
      elite: 47006933516439,
    },
    bifocals: {
      flat_top: 47006958846103,
      round_top: 47007020384407,
    },
    reading: {
      classic: 47007393317015,
      progressive: 47007470420119,
    },
    'non-prescription': {
      basic: 47007641993367,
      polycarbonate: 47007791579287,
      standard: 47007858131095,
      premium: 47007976521879,
    },
  };

  var LENS_OPTIONS_DATA = {
    single_vision: [
      {
        type: 'basic',
        price: 19.99,
        index: '1.56',
        name: 'Classic Lenses',
        description:
          'High-quality 1.56 index lenses with anti-scratch coating and UV protection. A dependable everyday choice for most standard prescriptions.',
      },
      {
        type: 'polycarbonate',
        price: 36.89,
        index: '1.59',
        name: 'Polycarbonate Lenses',
        description:
          'Lightweight and impact-resistant 1.59 index polycarbonate lenses. Recommended for sports, kids, and rimless frames. Not available with sunglass upgrades.',
      },
      {
        type: 'standard',
        price: 39.86,
        index: '1.60',
        name: 'Standard Thin Lenses',
        description:
          'High-quality 1.60 index lenses with anti-scratch coating and UV protection. A thinner and lighter upgrade for better comfort and appearance.',
      },
      {
        type: 'premium',
        price: 59.95,
        index: '1.67',
        name: 'Premium Thin Lenses',
        description:
          'High-index 1.67 lenses with anti-scratch coating and UV protection. Recommended for stronger prescriptions to help reduce lens thickness and weight.',
      },
      {
        type: 'elite',
        price: 97.83,
        index: '1.74',
        name: 'Elite Ultra-Thin Lenses',
        description:
          'Ultra-thin 1.74 high-index lenses with anti-scratch coating and UV protection. Best suited for high prescriptions where a slimmer, lighter lens profile is preferred.',
      },
    ],
    progressives: [
      {
        type: 'basic',
        price: 59.0,
        index: '1.56',
        name: 'Essential Progressive Lenses',
        description:
          'A practical progressive lens option for everyday distance, intermediate, and near vision. Suitable for general daily use and customers who want a reliable entry-level progressive solution.',
      },
      {
        type: 'standard',
        price: 79.0,
        index: '1.60',
        name: 'Standard Progressive Lenses',
        description:
          'An upgraded progressive lens option designed to provide smoother visual transitions and improved everyday comfort. A good choice for customers who use progressive lenses throughout the day.',
      },
      {
        type: 'premium',
        price: 96.0,
        index: '1.67',
        name: 'Premium Progressive Lenses',
        description:
          'A higher-performance progressive lens option with enhanced lens design for a more comfortable viewing experience across distance, intermediate, and near zones. Recommended for stronger prescriptions or customers who prefer a more refined progressive lens.',
      },
      {
        type: 'elite',
        price: 179.0,
        index: '1.74',
        name: 'Elite Progressive Lenses',
        description:
          'Our most advanced progressive lens option, designed for customers who want a more personalized and comfortable visual experience. Best suited for higher prescriptions, frequent progressive lens wearers, or customers who prefer the most refined lens option available.',
      },
    ],
    bifocals: [
      {
        type: 'flat_top',
        price: 49.99,
        index: '1.56',
        name: 'Flat-Top Bifocals',
        description:
          'A classic bifocal design with a visible D-shaped reading segment at the bottom of the lens. The upper area supports distance vision, while the lower segment provides a wider reading area for close-up tasks.',
      },
      {
        type: 'round_top',
        price: 49.9,
        index: '1.56',
        name: 'Round-Top Bifocals',
        description:
          'A bifocal design with a visible rounded reading segment at the bottom of the lens. It offers a softer segment shape and a more traditional appearance, with a smaller reading area than Flat-Top bifocals.',
      },
    ],
    reading: [
      {
        type: 'classic',
        price: 16.9,
        index: '',
        name: 'Classic Reading Lenses',
        description:
          'Simple reading lenses with the same reading magnification across the entire lens. Designed for near vision and close-up tasks such as reading, phone use, and desk work.',
      },
      {
        type: 'progressive',
        price: 39.79,
        index: '',
        name: 'Progressive Reading Lenses',
        description:
          'Progressive reading lenses with no distance prescription in the upper portion and reading magnification toward the lower portion. A practical option for customers who want to look around more naturally while still having reading support up close. Not intended for distance vision correction.',
      },
    ],
    'non-prescription': [
      {
        type: 'basic',
        price: 9.99,
        index: '1.56',
        name: 'Classic Clear Lenses',
        description:
          'Clear non-prescription 1.56 index lenses with anti-scratch coating and UV protection. A simple everyday option for fashion eyewear or frames without vision correction.',
      },
      {
        type: 'polycarbonate',
        price: 16.89,
        index: '1.59',
        name: 'Polycarbonate Clear Lenses',
        description:
          'Lightweight and impact-resistant 1.59 index polycarbonate lenses with no vision correction. Recommended for sports, kids, and rimless frames. Not available with sunglass tint upgrades.',
      },
      {
        type: 'standard',
        price: 29.86,
        index: '1.60',
        name: 'Standard Thin Clear Lenses',
        description:
          'Clear 1.60 index non-prescription lenses with anti-scratch coating and UV protection. A thinner and lighter option for a more refined lens appearance.',
      },
      {
        type: 'premium',
        price: 39.95,
        index: '1.67',
        name: 'Premium Thin Clear Lenses',
        description:
          'Clear 1.67 index non-prescription lenses with anti-scratch coating and UV protection. Designed for customers who prefer a thinner, lighter, and more premium lens profile.',
      },
    ],
  };

  var ADDON_VARIANTS = {
    blue_light: 47008730349719,
    anti_reflective: 47008810795159,
    case_cloth: 47008906870935,
    photochromic: 47008237781143,
    tinted: 47008354042007,
    polarized: 47008472694935,
    photochromic_polarized: 47008600129687,
    night_driving: 47729003430039,
  };

  var ADDON_RULES = {
    sun_color_exclusive: ['photochromic', 'tinted', 'polarized', 'photochromic_polarized', 'night_driving'],
    stackable: ['blue_light', 'anti_reflective', 'case_cloth'],
    bifocal_incompatible: ['polarized', 'photochromic_polarized', 'night_driving'],
  };

  var LENS_RECOMMENDATIONS = {
    BASIC_MAX: 2.0,
    STANDARD_MAX: 3.0,
    PREMIUM_MAX: 6.0,
  };

  var POLYCARBONATE_LENS_VARIANT_IDS = [];
  Object.keys(LENS_BASE_VARIANTS).forEach(function (usage) {
    var row = LENS_BASE_VARIANTS[usage];
    if (row && row.polycarbonate) {
      POLYCARBONATE_LENS_VARIANT_IDS.push(row.polycarbonate);
    }
  });

  var SUN_UPGRADE_ADDON_VARIANT_IDS = [];
  (ADDON_RULES.sun_color_exclusive || []).forEach(function (key) {
    var vid = ADDON_VARIANTS[key];
    if (vid) {
      SUN_UPGRADE_ADDON_VARIANT_IDS.push(vid);
    }
  });

  var BIFOCAL_INCOMPATIBLE_ADDON_VARIANT_IDS = [];
  (ADDON_RULES.bifocal_incompatible || []).forEach(function (key) {
    var vid = ADDON_VARIANTS[key];
    if (vid) {
      BIFOCAL_INCOMPATIBLE_ADDON_VARIANT_IDS.push(vid);
    }
  });

  // var API_BASE_URL = 'https://app.oletoptical.com';

  var API_BASE_URL = 'https://app.oletoptical.com';

  window.OletLens.Config = {
    PROPS: PROPS,
    BUNDLE_ROLES: BUNDLE_ROLES,
    STEPS: STEPS,
    STEP_TITLES: STEP_TITLES,
    STEP_TITLE_LENS_SELECTION_BY_USAGE: STEP_TITLE_LENS_SELECTION_BY_USAGE,
    POLYCARBONATE_NOTE: POLYCARBONATE_NOTE,
    PROGRESSIVES_PACKAGE_NOTE: PROGRESSIVES_PACKAGE_NOTE,
    BIFOCALS_NOTE: BIFOCALS_NOTE,
    READING_NOTE: READING_NOTE,
    LENS_BASE_VARIANTS: LENS_BASE_VARIANTS,
    LENS_OPTIONS_DATA: LENS_OPTIONS_DATA,
    ADDON_VARIANTS: ADDON_VARIANTS,
    ADDON_RULES: ADDON_RULES,
    LENS_RECOMMENDATIONS: LENS_RECOMMENDATIONS,
    POLYCARBONATE_LENS_VARIANT_IDS: POLYCARBONATE_LENS_VARIANT_IDS,
    SUN_UPGRADE_ADDON_VARIANT_IDS: SUN_UPGRADE_ADDON_VARIANT_IDS,
    BIFOCAL_INCOMPATIBLE_ADDON_VARIANT_IDS: BIFOCAL_INCOMPATIBLE_ADDON_VARIANT_IDS,
    API_BASE_URL: API_BASE_URL,
  };
})();
